import React, { forwardRef } from "react";

import { Button, type ButtonProps } from "./button";
import { Spinner } from "./spinner";

export type LoadingButtonProps = ButtonProps & {
  isLoading: boolean;
  srOnlyLoadingText?: string;
};

export const LoadingButton = forwardRef<HTMLButtonElement, LoadingButtonProps>(
  function LoadingButton(
    { isLoading, srOnlyLoadingText, disabled, children, ...props },
    forwardedRef,
  ) {
    return (
      <Button ref={forwardedRef} disabled={isLoading || disabled} {...props}>
        {isLoading ? (
          <div className="tw-relative">
            <span aria-hidden="true" className="tw-invisible">
              {children}
            </span>

            <Spinner
              srOnlyText={srOnlyLoadingText}
              className="tw-absolute tw-left-1/2 tw-top-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2"
            />
          </div>
        ) : (
          children
        )}
      </Button>
    );
  },
);
